import { createContext, useContext, useState, useEffect } from "react";

const ParentAuthContext = createContext();

export const ParentAuthProvider = ({ children }) => {
  const [parentToken, setParentToken] = useState(() => {
    const storedData = localStorage.getItem("parentAuth");
    if (storedData) {
      let parsedData;
      try {
        parsedData = JSON.parse(storedData);
      } catch (err) {
        localStorage.removeItem("parentAuth");
        return null;
      }
      if (Date.now() > parsedData.expiry) {
        localStorage.removeItem("parentAuth");
        return null;
      }
      return parsedData.token;
    }
    return null;
  });

  const [parentInfo, setParentInfo] = useState(() => {
    const storedData = localStorage.getItem("parentAuth");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      if (Date.now() > parsedData.expiry) {
        localStorage.removeItem("parentAuth");
        return null;
      }
      return parsedData.parentInfo;
    }
    return null;
  });

  useEffect(() => {
    const storedData = localStorage.getItem("parentAuth");

    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const timeLeft = parsedData.expiry - Date.now();

      if (timeLeft > 0) {
        const timeoutId = setTimeout(() => {
          localStorage.removeItem("parentAuth");
          setParentToken(null);
          setParentInfo(null);
          window.location.href = "/parent/login";
        }, timeLeft);

        return () => clearTimeout(timeoutId);
      } else {
        localStorage.removeItem("parentAuth");
        setParentToken(null);
        setParentInfo(null);
        window.location.href = "/parent/login";
      }
    }
  }, []);

  useEffect(() => {
    if (parentToken && parentInfo) {
      const expiryTime = Date.now() + 60 * 60 * 1000;
      const authData = { token: parentToken, parentInfo, expiry: expiryTime };
      localStorage.setItem("parentAuth", JSON.stringify(authData));
    } else {
      localStorage.removeItem("parentAuth");
    }
  }, [parentToken, parentInfo]);

  return (
    <ParentAuthContext.Provider value={{ parentToken, setParentToken, parentInfo, setParentInfo }}>
      {children}
    </ParentAuthContext.Provider>
  );
};

export const useParentAuth = () => useContext(ParentAuthContext);